import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import { CreditCardsConsentError } from "@/app/lib/errors/CreditCardsConsentError";
import { platformApi } from "@/app/lib/platform";
import {
  BnplTrackingEvents,
  CommonTrackingEvents,
  rudderAnalytics,
} from "@/app/lib/rudderstack";
import type { CustomerEligibilityOutput } from "@/types/types";

export const isUserEligibleQueryOptions = (
  cardNumber: string = "",
  enabled: boolean,
) =>
  queryOptions({
    queryKey: ["eligible", cardNumber],
    queryFn: async ({ queryKey: [, cardNumber], signal }) => {
      try {
        const payload = await platformApi.getEligibilityPayload(
          cardNumber || undefined,
        );

        const response = await api.post<{
          data: CustomerEligibilityOutput;
        }>(`/transactions/aqsati/check-eligibility`, payload, { signal });

        const eventName = response.data.data.isEligible
          ? BnplTrackingEvents.USER_PASSED_ELIGIBILITY_CHECK
          : BnplTrackingEvents.USER_FAILED_ELIGIBILITY_CHECK;

        rudderAnalytics.track(eventName);

        return response;
      } catch (error) {
        if (
          error instanceof CreditCardsConsentError &&
          error.cause === "cancelled"
        ) {
          rudderAnalytics.track(CommonTrackingEvents.USER_REJECTED_CONSENT, {
            scope: "credit_card_information",
          });
        }

        throw error;
      }
    },
    select: (response) => {
      return response.data?.data;
    },
    retry: false,
    enabled,
    throwOnError: false,
  });
